import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const TitleWrapper = styled.header`
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  text-align: center;
  border-bottom: solid 1px ${({ theme }) => theme.dividerColor};
  padding-top: 25px;
  padding-bottom: 15px;
  padding-right: 45px;
  padding-left: 45px;
  width: 100%;
  ${media.desktop`
    padding-top: 35px;
    padding-bottom: 28px;
    width: 90%;
  `}
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.primaryColor};
  ${fontSize(18)};
  font-weight: normal;
  ${media.desktop`
    ${fontSize(32)};
    margin-bottom: 10px;
  `}
`;

export const SubTitle = styled.h2`
  color: ${({ theme }) => theme.primaryColor};
  ${fontSize(18)};
  font-weight: normal;
  ${media.desktop`
    ${fontSize(24)}
  `}
`;
